(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cookie-consent"] && !Shopify.designMode) return;
  try {
    (function () {
  'use strict';

  var STORAGE_KEY = 'cookie_consent_v1';

  var banner = document.getElementById('cookie-consent-banner');
  var mainView = document.getElementById('cookie-consent-main');
  var panelView = document.getElementById('cookie-consent-panel');
  var reopenBtn = document.getElementById('cookie-consent-reopen');

  var acceptBtn = document.getElementById('cookie-consent-accept');
  var rejectBtn = document.getElementById('cookie-consent-reject');
  var customizeBtn = document.getElementById('cookie-consent-customize');
  var backBtn = document.getElementById('cookie-consent-back');
  var saveBtn = document.getElementById('cookie-consent-save');

  var functionalCheckbox = document.getElementById('cookie-consent-functional');
  var analyticsCheckbox = document.getElementById('cookie-consent-analytics');
  var marketingCheckbox = document.getElementById('cookie-consent-marketing');

  if (
    !banner || !mainView || !panelView || !reopenBtn ||
    !acceptBtn || !rejectBtn || !customizeBtn || !backBtn || !saveBtn ||
    !functionalCheckbox || !analyticsCheckbox || !marketingCheckbox
  ) {
    return;
  }

  var shopifyPrivacyReady = false;

  /* ============================================================
     ALMACENAMIENTO LOCAL
     Controla únicamente nuestra interfaz.
     ============================================================ */

  function getConsent() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : null;
    } catch (e) {
      return null;
    }
  }

  function saveLocalConsent(consent) {
    try {
      consent.timestamp = new Date().toISOString();
      localStorage.setItem(STORAGE_KEY, JSON.stringify(consent));
    } catch (e) {
      /* Si localStorage está bloqueado, la barra sigue siendo utilizable. */
    }
  }

  /* ============================================================
     INTERFAZ
     ============================================================ */

  var bannerHasBeenShown = false;
  var revealToken = 0;

  function revealBannerNow(token) {
    if (token !== revealToken) return;

    banner.hidden = false;
    reopenBtn.hidden = true;
    bannerHasBeenShown = true;
  }

  function showBanner() {
    revealToken += 1;
    var token = revealToken;

    reopenBtn.hidden = true;

    /*
      En la primera aparición esperamos a que Figtree esté lista.
      Así el visitante no ve primero la fuente provisional y después
      un reajuste de textos/botones cuando termina de cargar la fuente.
    */
    if (!bannerHasBeenShown && document.fonts && document.fonts.load) {
      Promise.all([
        document.fonts.load("300 14px Figtree"),
        document.fonts.load("400 14px Figtree")
      ]).then(function () {
        revealBannerNow(token);
      }).catch(function () {
        revealBannerNow(token);
      });

      return;
    }

    revealBannerNow(token);
  }

  function hideBanner() {
    revealToken += 1;
    banner.hidden = true;
    reopenBtn.hidden = false;
  }

  function showPanel() {
    mainView.hidden = true;
    panelView.hidden = false;
  }

  function showMain() {
    panelView.hidden = true;
    mainView.hidden = false;
  }

  function syncCheckboxes(consent) {
    if (!consent) return;

    functionalCheckbox.checked = !!consent.functional;
    analyticsCheckbox.checked = !!consent.analytics;
    marketingCheckbox.checked = !!consent.marketing;
  }

  /* ============================================================
     SCRIPTS EXTERNOS OPCIONALES
     ============================================================ */

  function applyConsent(consent) {
    document.dispatchEvent(
      new CustomEvent('cookieConsentUpdated', { detail: consent })
    );

    if (consent.functional) {
      loadFunctional();
    }

    if (consent.analytics) {
      loadAnalytics();
    }

    if (consent.marketing) {
      loadMarketing();
    }
  }

  function loadFunctional() {
    if (window.__creartenFunctionalLoaded) return;
    window.__creartenFunctionalLoaded = true;

    // Scripts externos de funcionalidad, si algún día hacen falta.
  }

  function loadAnalytics() {
    if (window.__creartenAnalyticsLoaded) return;
    window.__creartenAnalyticsLoaded = true;

    // Scripts externos de analítica que NO gestione ya Shopify o una app.
  }

  function loadMarketing() {
    if (window.__creartenMarketingLoaded) return;
    window.__creartenMarketingLoaded = true;

    // Scripts externos de marketing que NO gestione ya Shopify o una app.
  }

  /* ============================================================
     SHOPIFY CUSTOMER PRIVACY API
     No controla la aparición de la barra.
     Solo sincroniza la decisión del visitante.
     ============================================================ */

  function syncConsentWithShopify(consent) {
    if (
      !shopifyPrivacyReady ||
      !window.Shopify ||
      !window.Shopify.customerPrivacy ||
      typeof window.Shopify.customerPrivacy.setTrackingConsent !== 'function'
    ) {
      return;
    }

    window.Shopify.customerPrivacy.setTrackingConsent(
      {
        preferences: !!consent.functional,
        analytics: !!consent.analytics,
        marketing: !!consent.marketing
      },
      function () {}
    );
  }

  function initShopifyPrivacy() {
    if (
      !window.Shopify ||
      typeof window.Shopify.loadFeatures !== 'function'
    ) {
      return;
    }

    window.Shopify.loadFeatures(
      [
        {
          name: 'consent-tracking-api',
          version: '0.1'
        }
      ],
      function (error) {
        if (
          !error &&
          window.Shopify &&
          window.Shopify.customerPrivacy
        ) {
          shopifyPrivacyReady = true;
        }
      }
    );
  }

  /* ============================================================
     GUARDAR DECISIÓN
     Primero guardamos y actualizamos nuestra UI.
     Shopify se sincroniza en paralelo y nunca bloquea el banner.
     ============================================================ */

  function saveConsent(consent) {
    consent.necessary = true;

    saveLocalConsent(consent);
    applyConsent(consent);
    syncConsentWithShopify(consent);
    hideBanner();
  }

  /* ============================================================
     EVENTOS
     ============================================================ */

  acceptBtn.addEventListener('click', function () {
    saveConsent({
      functional: true,
      analytics: true,
      marketing: true
    });
  });

  rejectBtn.addEventListener('click', function () {
    saveConsent({
      functional: false,
      analytics: false,
      marketing: false
    });
  });

  customizeBtn.addEventListener('click', function () {
    var existing = getConsent();

    if (existing) {
      syncCheckboxes(existing);
    }

    showPanel();
  });

  backBtn.addEventListener('click', showMain);

  saveBtn.addEventListener('click', function () {
    saveConsent({
      functional: functionalCheckbox.checked,
      analytics: analyticsCheckbox.checked,
      marketing: marketingCheckbox.checked
    });
  });

  reopenBtn.addEventListener('click', function () {
    var existing = getConsent();

    if (existing) {
      syncCheckboxes(existing);
      showPanel();
    } else {
      showMain();
    }

    showBanner();
  });

  /* ============================================================
     INICIO
     La aparición depende SOLO de nuestro almacenamiento local.
     ============================================================ */

  var existingConsent = getConsent();

  if (existingConsent) {
    syncCheckboxes(existingConsent);
    applyConsent(existingConsent);
    hideBanner();
  } else {
    showMain();
    showBanner();
  }

  initShopifyPrivacy();
})();
  } catch(e) { console.error(e); }
})();

})();
